import { Outlet, createFileRoute } from "@tanstack/react-router";
import { LeadGenProvider } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads")({
    component: LeadGenLayout,
});

function LeadGenLayout() {
    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
    ]);

    return (
        <LeadGenProvider>
            <section className="flex flex-col gap-4 p-4 overflow-x-hidden">
                <Outlet />
            </section>
        </LeadGenProvider>
    );
}
